/**
 * Created by Rodrigo Quesada on 27/03/17.
 */
import {NgModule} from '@angular/core';
import {LocalStorageModule as ThirdPartyLocalStorageModule} from 'angular-2-local-storage';
import {config} from './local-storage.config';

@NgModule({
    imports: [ThirdPartyLocalStorageModule.withConfig(config)]
})
export class LocalStorageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/infrastructure/local-storage/local-storage.module.ts